export class DialogEvent {
    public static WELCOME = 'welcome';
    public static START_TYPING = 'starttyping';
    public static MESSAGE_SENDING_STARTED = 'MESSAGE_SENDING_STARTED';
    public static MESSAGE_SENDING_FINISHED = 'MESSAGE_SENDING_FINISHED';
    public static THINKING_INDICATOR = 'THINKING_INDICATOR';
    public static ALREADY_CONNECTED_IN_OTHER_WINDOW: string = 'ALREADY_CONNECTED_IN_OTHER_WINDOW';
    public static CONNECTED: string = 'CONNECTED';
    public static AUTHENTICATION_FAILED_FIRST_TRY: string = 'AUTHENTICATION_FAILED_FIRST_TRY';
    public static AUTHENTICATION_FAILED_SECOND_TRY: string = 'AUTHENTICATION_FAILED_SECOND_TRY';
}
